<template>
  <b-row>
    <b-col cols="12">
      <h1 class="mb-0 hp-text-color-black-1">Настройки</h1>
      <p>На этой странице вы можете настроить систему</p>
    </b-col>

    <b-col>
      <b-card class="rounded">
        <b-card-title> Настройки SIP-транка </b-card-title>
        <b-card-sub-title class="mb-3"> Входящий вызов </b-card-sub-title>

        <b-form @submit="updateSettings">
          <b-form-row class="mb-1">
            <b-col> <label class="mr-sm-2">Регистрация:</label></b-col>
            <b-col>
              <b-form-radio-group v-model="form.sip_trunk.register">
                <b-form-radio :value="true">Да</b-form-radio>
                <b-form-radio :value="false">Нет</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-form-row>

          <ValidationObserver v-slot="{ valid }">
            <validation-provider v-if="!form.sip_trunk.register"
              name="ip адрес"
              :rules="{
                required: true,
                regex: /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col>
                  <label inline class="mr-sm-2" for="domain-input">IP адрес:</label>
                </b-col>
                <b-col>
                  <b-form-input
                    id="domain-input"
                    v-model="form.sip_trunk.ip"
                    placeholder="Введите ip адрес"
                    required
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }">
                  </b-form-input>
                  <div
                    v-if="errors && errors.length != 0"
                    class="invalid-feedback d-inline-block"
                  >
                    <ul>
                      <li v-for="error in errors">{{ error }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-form-row>
            </validation-provider>

            <validation-provider v-if="!form.sip_trunk.register"
              name="порт"
              :rules="{
                required: true,
                regex: /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col>
                  <label class="mr-sm-2" for="port-input-sip" >Порт:</label>
                </b-col>
                <b-col>
                  <b-form-input
                    id="port-input-sip"
                    v-model="form.sip_trunk.port"
                    type="number"
                    placeholder="Введите порт"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }">
                  </b-form-input>
                </b-col>
              </b-form-row>
            </validation-provider>
            <b-form-row class="mb-1" v-if="form.sip_trunk.register">
              <b-col>
                <label class="mr-sm-2" for="inn-input-sip">Логин для авторизации (ИНН):</label>
              </b-col>
              <b-col>
                <b-form-input id="inn-input-sip" v-model="form.sip_trunk.inn" placeholder="Введите ИНН" disabled/>
              </b-col>
            </b-form-row>
            <validation-provider v-if="form.sip_trunk.register" name="пароль" :rules="'verify_password|required'"
              v-slot="{ dirty, valid, invalid, errors }">
              <b-form-row class="mb-1">
                <b-col>
                  <label class="mr-sm-2" for="password-input-sip">Пароль:</label>
                </b-col>
                <b-col>
                  <b-input-group>
                    <b-form-input
                      id="password-input-sip"
                      v-model="form.sip_trunk.password"
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                      v-bind:type="showPassword ? 'text' : 'password'"
                      required/>
                    <b-input-group-append>
                      <b-button
                        @click="showPassword = !showPassword"
                        variant="outline-primary"
                        size="sm"
                        ><i
                          v-if="!showPassword"
                          class="hp-text-color-dark-0 iconly-Light-Show"
                        ></i>
                        <i
                          v-else
                          class="hp-text-color-dark-0 iconly-Light-Hide"
                        ></i>
                      </b-button>
                      <b-button
                        @click="form.sip_trunk.password = gen_password(20)"
                        variant="outline-primary"
                        size="sm">
                        <i class="hp-text-color-dark-0 iconly-Light-Password"/>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="invalid-feedback d-inline-block" v-show="errors">
                    <ul>
                      <li v-for="error in errors">{{ error }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-form-row>
            </validation-provider>
            <validation-provider
                        name="длительность набора"
                        :rules="{
                          required: true,
                          regex: /^([0-9]+)$/,
                        }"
                        v-slot="{ dirty, valid, invalid, errors }">
                        <b-form-row class="mb-1">
                          <b-col>
                            <label class="mr-sm-2" for="dialing-duration-input-sip" >Длительность набора:</label>
                          </b-col>
                          <b-col>
                            <b-form-input
                              id="dialing-duration-input-sip"
                              v-model="form.sip_trunk.dialing_duration"
                              type="number"
                              placeholder="Введите длительность набора"
                              v-bind:class="{
                                'is-valid': dirty && valid,
                                'is-invalid': dirty && invalid,
                              }">
                            </b-form-input>
                          </b-col>
                        </b-form-row>
             </validation-provider>
             <b-button type="submit"  variant="primary" class="mb-8 mr-8" :disabled="!valid">Сохранить</b-button>
           </ValidationObserver>
        </b-form>
      </b-card>

      <b-card class="rounded mt-3">
        <b-card-title> Outbound proxy </b-card-title>
        <b-card-sub-title class="mb-3">
          Подраздел настройки SIP-транка исходящий вызов
        </b-card-sub-title>
        <b-form-checkbox class="mb-3" v-model="form.same_as_input"
          >Совпадает с входящим</b-form-checkbox
        >
        <ValidationObserver v-slot="{ valid }">
          <b-form v-if="!form.same_as_input" @submit="updateSettings">
            <validation-provider
              name="адрес провайдера"
              :rules="'required'"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col
                  ><label inline class="mr-sm-2" for="fqdn-input"
                    >Адрес провайдера (FQDN):</label
                  ></b-col
                >
                <b-col
                  ><b-form-input
                    id="fqdn-input"
                    v-model="form.outbound_proxy.domain"
                    type="text"
                    placeholder="Введите адрес"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                  ></b-form-input
                ></b-col>
              </b-form-row>
            </validation-provider>

            <validation-provider
              name="порт"
              :rules="{
                required: true,
                regex:
                  /^([1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col>
                  <label class="mr-sm-2" for="port-input-outbound"
                    >Порт:</label
                  ></b-col
                >
                <b-col
                  ><b-form-input
                    id="port-input-outbound"
                    v-model="form.outbound_proxy.port"
                    type="number"
                    placeholder="Введите порт"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                  ></b-form-input
                ></b-col>
              </b-form-row>
            </validation-provider>

            <b-form-row class="mb-1">
              <b-col> <label class="mr-sm-2">Регистрация:</label></b-col>
              <b-col
                ><b-form-radio-group v-model="form.outbound_proxy.register">
                  <b-form-radio :value="true">Да</b-form-radio>
                  <b-form-radio :value="false">Нет</b-form-radio>
                </b-form-radio-group></b-col
              >
            </b-form-row>

            <b-form-row class="mb-1">
              <b-col
                ><label inline class="mr-sm-2" for="protocol-input"
                  >Протокол:</label
                ></b-col
              >
              <b-col>
                <b-form-select
                  id="protocol-input"
                  v-model="form.outbound_proxy.protocol"
                  class="mb-3"
                >
                  <b-form-select-option value="udp" selected>
                    udp
                  </b-form-select-option>
                  <b-form-select-option value="tcp">tcp</b-form-select-option>
                  <b-form-select-option value="tls"> tls </b-form-select-option>
                </b-form-select>
              </b-col>
            </b-form-row>

            <validation-provider
              name="имя пользователя"
              :rules="outboundUsernameRules"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col
                  ><label class="mr-sm-2" for="username-input-outbound"
                    >Имя пользователя (From User):</label
                  ></b-col
                >
                <b-col
                  ><b-form-input
                    id="username-input-outbound"
                    v-model="form.outbound_proxy.username"
                    type="text"
                    placeholder="User Name"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                  ></b-form-input
                ></b-col>
              </b-form-row>
            </validation-provider>

            <validation-provider
              v-if="form.outbound_proxy.register"
              name="логин"
              :rules="{
                required: true,
              }"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col
                  ><label class="mr-sm-2" for="inn-input-outbound"
                    >Логин:</label
                  ></b-col
                >
                <b-col
                  ><b-form-input
                    id="inn-input-outbound"
                    v-model="form.outbound_proxy.login"
                    type="text"
                    v-bind:class="{
                      'is-valid': dirty && valid,
                      'is-invalid': dirty && invalid,
                    }"
                  ></b-form-input
                ></b-col>
              </b-form-row>
            </validation-provider>

            <validation-provider
              v-if="form.outbound_proxy.register"
              name="пароль"
              :rules="'required'"
              v-slot="{ dirty, valid, invalid, errors }"
            >
              <b-form-row class="mb-1">
                <b-col
                  ><label class="mr-sm-2" for="password-input-outbound"
                    >Пароль:</label
                  ></b-col
                >
                <b-col>
                  <b-input-group>
                    <b-form-input
                      name="password-input-outbound"
                      id="password-input-outbound"
                      v-model="form.outbound_proxy.password"
                      v-bind:type="showPassword ? 'text' : 'password'"
                      v-bind:class="{
                        'is-valid': dirty && valid,
                        'is-invalid': dirty && invalid,
                      }"
                      required
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="showPassword = !showPassword"
                        variant="outline-primary"
                        size="sm"
                        ><i
                          v-if="!showPassword"
                          class="hp-text-color-dark-0 iconly-Light-Show"
                        ></i>
                        <i
                          v-else
                          class="hp-text-color-dark-0 iconly-Light-Hide"
                        ></i>
                      </b-button>
                      <b-button
                        @click="form.outbound_proxy.password = gen_password(20)"
                        variant="outline-primary"
                        size="sm"
                        ><i
                          class="hp-text-color-dark-0 iconly-Light-Password"
                        ></i
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  <div class="invalid-feedback d-inline-block" v-show="errors">
                    <ul>
                      <li v-for="error in errors">{{ error }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-form-row>
            </validation-provider>

            <b-form-row class="mb-1">
              <b-col
                ><label class="mr-sm-2" for="from-domain-input-outbound"
                  >Значение поля domain в заголовке From:</label
                ></b-col
              >
              <b-col
                ><b-form-input
                  id="from-domain-input-outbound"
                  v-model="form.outbound_proxy.from_domain"
                  type="text"
                  placeholder="1"
                ></b-form-input
              ></b-col>
            </b-form-row>

            <b-form-row class="mb-1">
              <b-col
                ><label class="mr-sm-2" for="to-domain-input-outbound"
                  >Значение поля domain в заголовке To:</label
                ></b-col
              >
              <b-col
                ><b-form-input
                  id="to-domain-input-outbound"
                  v-model="form.outbound_proxy.to_domain"
                  type="text"
                  placeholder="1"
                ></b-form-input
              ></b-col>
            </b-form-row>

            <b-button
              type="submit"
              variant="primary"
              class="mb-8 mr-8"
              :disabled="!valid"
              >Сохранить</b-button
            >
          </b-form>
        </ValidationObserver>
      </b-card>
    </b-col>
    <b-col>
      <ConfidenceLevelCard
        description="true"
        :default="form.confidence"
        @save-confidence-settings="getConfidenceLevel"
      />
      <!-- <b-card class="mt-3" header="Form Data Result">
        <pre class="m-0 hp-p1-body">{{ form }}</pre>
      </b-card> -->
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BForm,
  BFormInput,
  BFormText,
  BFormGroup,
  BFormRadioGroup,
  BFormSelect,
  BFormSelectOption,
  BFormRadio,
  BCardTitle,
  BCardSubTitle,
  BFormRow,
  BFormCheckbox,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";

import ConfidenceLevelCard from "./ConfidenceLevelCard.vue";
import axios from "axios";

export default {
  props: ["errors"],
  data() {
    return {
      showPassword: false,
      form: {
        same_as_input: false,
        confidence: 12,
        sip_trunk: {
          ip: null,
          port: null,
          dialing_duration: null,
          inn: this.$store.state.user["inn"],
          password: null,
          register: false,
        },
        outbound_proxy: {
          domain: null,
          register: false,
          port: null,
          protocol: "udp",
          username: null,
          login: null,
          password: null,
          from_domain: null,
          to_domain: null,
        },
      },
    };
  },
  computed: {
    outboundUsernameRules() {
      return !this.form.outbound_proxy.register ? { } : { required: true };
    }
  },
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    ConfidenceLevelCard,
    BForm,
    BFormInput,
    BFormText,
    BFormGroup,
    BFormRadioGroup,
    BFormSelect,
    BFormSelectOption,
    BFormRadio,
    BCardTitle,
    BCardSubTitle,
    BFormRow,
    BFormCheckbox,
    BInputGroupAppend,
    BInputGroup,
  },
  methods: {
    getConfidenceLevel(value) {
      this.form.confidence = value;
    },
    async updateSettings(event) {
      event.preventDefault();
      try {
        const data = JSON.parse(JSON.stringify(this.form))
        if (this.form.outbound_proxy && !this.form.outbound_proxy.register) {
          // не создавать и не сохранять пароль при выборе "регистрация -- нет"
          data.outbound_proxy.password = undefined
        }
        const response = await axios.post(
          `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/customer/${this.$store.state.user["inn"]}/sip`,
            data,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log(response);
        this.$router.go();
      } catch (e) {
        if (e.response.status == 429) {
          alert("Подождите немного. Вы слишком часто меняете настройки");
        } else {
          console.warn("Can't change settings", e);
        }
        return;
      }
    },
    async getCurrentSettings() {
      const { data } = await axios.get(
        `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/api/v1.0/customer/${this.$store.state.user["inn"]}/sip`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      this.form = {
        same_as_input: data.outbound_same_as_inbound,
        confidence: data.confidence_level,
        sip_trunk: {
          ip: data.inbound_domain,
          port: data.inbound_port,
          inn: data.inbound_inn,
          password: data.inbound_password,
          register: data.inbound_register,
          dialing_duration: data.inbound_dialing_duration,
        },
        outbound_proxy: {
          domain: data.outbound_domain,
          port: data.outbound_port,
          register: data.outbound_register,
          protocol: data.outbound_protocol,
          username: data.outbound_username,
          login: data.outbound_login,
          password: data.outbound_password,
          from_domain: data.outbound_from_domain,
          to_domain: data.outbound_to_domain,
        },
      };
    },
    gen_password(len) {
      var password = "";
      var upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      var cntUpper = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntUpper; i++) {
        password += upperCase.charAt(
          Math.floor(Math.random() * upperCase.length)
        );
      }

      var lowerCase = "abcdefghijklmnopqrstuvwxyz";
      var cntLower = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntLower; i++) {
        password += lowerCase.charAt(
          Math.floor(Math.random() * lowerCase.length)
        );
      }

      var numbers = "0123456789";
      var cntNumber = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntNumber; i++) {
        password += numbers.charAt(Math.floor(Math.random() * numbers.length));
      }

      var specSymbols = "!@#$%^&*";
      var cntSpec = Math.floor(Math.random() * 3) + 1;
      for (var i = 0; i < cntSpec; i++) {
        password += specSymbols.charAt(
          Math.floor(Math.random() * specSymbols.length)
        );
      }
      var shuffled_password = password
        .split("")
        .sort(function () {
          return 0.5 - Math.random();
        })
        .join("");

      var symbols =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";

      while (shuffled_password.length < len) {
        shuffled_password += symbols.charAt(
          Math.floor(Math.random() * symbols.length)
        );
      }
      return shuffled_password;
    },
  },
  async beforeMount() {
    await this.getCurrentSettings();
  },
};
</script>
